import * as _ from "lodash";
import * as types from "./types";
import {
  setFilterUsers,
  setFilterTags,
  setFilterTeams,
  setFilterScope,
  clearAllFilters,
} from "./reducerFilterContacts";
import {
  addCountTabs,
  removeAndAddCountTabs,
  removeCountTabs,
  updatedState,
} from "./utils";

const updateContact = (state, action) => {
  const contacts = state?.contacts;
  const search = state?.searchContacts?.find(
    (c) => c?.id == action?.contact?.id
  );
  const foundTag = action?.contact?.customer_tag_ids?.find((tag_id) =>
    state?.filterTags?.includes(tag_id)
  );
  const index = contacts?.findIndex(
    (contact) => contact?.id == action?.contact?.id
  );
  const oldContact = contacts[index];
  let updateTabs = {};

  if (oldContact) {
    action.contact.avatar_url = oldContact?.avatar_url;
  }

  //users filtered forward contact
  if (
    state?.filterUsers?.includes(oldContact?.user?.id) &&
    !state?.filterUsers?.includes(action?.contact?.user?.id)
  ) {
    updateTabs = removeCountTabs(action?.contact, state);
    return updatedState(
      state,
      updateTabs,
      contacts.filter((contact) => contact?.id !== action?.contact?.id)
    );
  }

  //users filtered receive new message
  if (
    state?.filterUsers?.length > 0 &&
    !state?.filterUsers?.includes(action?.contact?.user?.id)
  ) {
    return state;
  }

  //standard update
  updateTabs = removeAndAddCountTabs(oldContact, action?.contact, state);
  contacts.splice(index, 1, action?.contact);

  // update list search if found
  if (search) {
    const newList = state?.searchContacts?.filter(
      (c) => c?.id != action?.contact?.id
    );
    return {
      ...state,
      searchContacts: _.orderBy(
        [...newList, action?.contact],
        "updated_at",
        "desc"
      ),
    };
  }

  //interact while scope filtered (not_interacted)
  if (
    action?.contact?.interacted_at !== null &&
    state?.filterScope?.name == "not_interacted"
  ) {
    updateTabs = removeCountTabs(oldContact, state);
    return updatedState(
      state,
      updateTabs,
      contacts.filter((contact) => contact?.id !== action?.contact?.id)
    );
  }

  //read messages while scope filtered (unread_messages)
  if (
    action?.contact?.unread_messages_count === 0 &&
    state?.filterScope?.name == "unread_messages"
  ) {
    updateTabs = removeCountTabs(oldContact, state);
    return updatedState(
      state,
      updateTabs,
      contacts.filter((contact) => contact?.id !== action?.contact?.id)
    );
  }

  // remove tag while tag filtered
  if (!foundTag && state?.filterTags?.length > 0) {
    updateTabs = removeCountTabs(oldContact, state);
    return updatedState(
      state,
      updateTabs,
      contacts.filter((contact) => contact?.id !== action?.contact?.id)
    );
  }

  return updatedState(state, updateTabs, [...contacts]);
};

const addContactFromList = (state, action) => {
  const index = state?.contacts?.findIndex(
    (contact) => contact?.id == action?.contact?.id
  );

  if (
    state?.filterUsers?.length > 0 &&
    !state?.filterUsers?.includes(action?.contact?.user?.id)
  ) {
    return state;
  }

  if (index == -1) {
    let updateTabs = {};

    updateTabs = addCountTabs(action?.contact, state);

    return updatedState(state, updateTabs, [
      ...state?.contacts,
      action?.contact,
    ]);
  }

  return state;
};

const removeContact = (state, action) => {
  let updateTabs = {};

  updateTabs = removeCountTabs(action?.contact, state);

  return updatedState(
    state,
    updateTabs,
    state.contacts.filter((contact) => contact?.id !== action?.contact?.id)
  );
};

const overwriteContacts = (state, action) => ({
  ...state,
  contacts: [...action?.contacts],
});

const overwriteTotals = (state, action) => {
  const newTotals = {
    ...state,
    ...action?.totals,
    totals: {
      ...action?.totals,
    },
  };
  return newTotals;
};

const overwriteSearchContacts = (state, action) => ({
  ...state,
  searchContacts: [...action?.searchContacts],
});

const contactsLoading = (state, action) => ({
  ...state,
  isContactsLoading: action.isContactsLoading,
});

export function reducer(prevState, action) {
  switch (action.type) {
    case types.UPDATE_MAIN:
      return {
        ...prevState,
        ...action.data,
      };
    case types.MAIN_UPDATE_USERS:
      return {
        ...prevState,
        users: action.users,
      };
    case types.MAIN_UPDATE_CREDENTIALS:
      return {
        ...prevState,
        credentials: action.credentials,
      };
    case types.MAIN_UPDATE_WHATSAPP_STATUS:
      return {
        ...prevState,
        whatsappOn: action.whatsappOn,
      };
    case types.UPDATE_CONTACT_FROM_LIST:
      return updateContact(prevState, action);
    case types.UPDATE_CONTACT_LIST:
      return overwriteContacts(prevState, action);
    case types.ADD_CONTACT_FROM_LIST:
      return addContactFromList(prevState, action);
    case types.REMOVE_CONTACT_FROM_LIST:
      return removeContact(prevState, action);
    case types.OVERWRITE_TOTALS:
      return overwriteTotals(prevState, action);
    case types.OVERWRITE_SEARCH_CONTACTS:
      return overwriteSearchContacts(prevState, action);
    case types.SET_FILTER_USERS:
      return setFilterUsers(prevState, action);
    case types.SET_FILTER_TAGS:
      return setFilterTags(prevState, action);
    case types.SET_FILTER_TEAMS:
      return setFilterTeams(prevState, action);
    case types.SET_FILTER_SCOPE:
      return setFilterScope(prevState, action);
    case types.CLEAR_ALL_FILTERS:
      return clearAllFilters(prevState, action);
    case types.CONTACTS_LOADING:
      return contactsLoading(prevState, action);
    default:
      return prevState;
  }
}
